let ts;
if (import.meta.client) {
  document.addEventListener("touchstart", function (e) {
    ts = e.touches[0].clientY;
  });
}

function preventDefault(e) {
  e = e || window.event;
  var area;
  if (e.target.closest(".mobileRow")) {
    area = e.target.closest(".mobileRow");
  } else if (e.target.closest(".cky-preference-body-wrapper")) {
    area = e.target.closest(".cky-preference-body-wrapper");
  } else {
    area = e.target;
  }
  var parentPopup = (() => {
    if (e.target.classList.contains("popupContent")) return true;

    let target = e.target;
    let closestMatch = null;

    if (target.closest(".cky-preference-body-wrapper")) return true;

    while (target !== null) {
      if (target.matches(".mobileRow")) {
        closestMatch = target;
        break;
      }
      target = target.parentElement;
    }
    return closestMatch !== null ? 1 : 0;
  })();

  if (!parentPopup) {
    e.preventDefault();
    e.returnValue = false;
    return false;
  }
  var delta = e.deltaY || e.detail || e.wheelDelta;
  if (e.type == "touchmove") {
    var tob = e.changedTouches[0]; // reference first touch point for this event
    var offset = parseInt(tob.clientY);
    if (ts < offset - 5) {
      delta = -100;
    } else if (ts > offset + 5) {
      delta = 100;
    }
  }

  if (delta <= 0 && area.scrollTop <= 0) {
    e.preventDefault();
  }
  if (
    delta > 0 &&
    area.scrollHeight - area.clientHeight - area.scrollTop <= 1
  ) {
    e.preventDefault();
  }
}

function holdScroll(e) {
  e = e || window.event;
  if (e.preventDefault) e.preventDefault();
  e.returnValue = false;
  return false;
}

const HoldAllScrollPage = (fix = false) => {
  HoldScrollPagePosition(fix);
  if (fix) {
    document.body.classList.add("no-scroll");
    window.addEventListener("scroll", holdScroll, { passive: false });
    window.addEventListener("wheel", holdScroll, { passive: false });
    window.addEventListener("DOMMouseScroll", holdScroll, { passive: false });
    document.addEventListener("touchmove", holdScroll, { passive: false });
    window.addEventListener("keydown", preventDefaultForScrollKeys, {
      passive: false,
    });
  } else {
    document.body.classList.remove("no-scroll");
    window.removeEventListener("scroll", holdScroll, { passive: false });
    window.removeEventListener("wheel", holdScroll, { passive: false });
    window.removeEventListener("DOMMouseScroll", holdScroll, {
      passive: false,
    });
    document.removeEventListener("touchmove", holdScroll, { passive: false });
    window.removeEventListener("keydown", preventDefaultForScrollKeys, {
      passive: false,
    });
  }
};
function preventDefaultForScrollKeys(e) {
  // Prevent scrolling with arrow keys, spacebar, page up/down, home/end
  if ([37, 38, 39, 40, 32, 33, 34, 35, 36].includes(e.keyCode)) {
    e.preventDefault();
  }
}
const HoldScrollPage = (fix = false) => {
  HoldScrollPagePosition(fix);
  if (fix) {
    window.addEventListener("wheel", preventDefault, { passive: false });
    window.addEventListener("DOMMouseScroll", preventDefault, {
      passive: false,
    });
    document.addEventListener("touchmove", preventDefault, { passive: false });
    // $(document).on("touchmove", preventDefault)
  } else {
    window.removeEventListener("wheel", preventDefault, { passive: false });
    window.removeEventListener("DOMMouseScroll", preventDefault, {
      passive: false,
    });
    document.removeEventListener("touchmove", preventDefault, {
      passive: false,
    });
  }
};
const HoldScrollPagePosition = (fix = false) => {
  // console.log("HoldScrollPagePosition", fix, window.lenis);
  if (window.lenis) window.lenis[fix ? "stop" : "start"]();
};

export { HoldAllScrollPage, HoldScrollPage, HoldScrollPagePosition };
